import type { GetStaticProps, GetStaticPaths, GetServerSideProps } from "next";
import { ApiService } from "services/server";
import { Tab } from "views";
import { labDetailsNormalizer } from "utils/normalizer";
import { useEffect, useMemo, useState } from "react";
import { REVALIDATE_TIME, TAG_TREES } from "utils/constants";
import { checkEmpty, is404, isCorrectLocale } from "utils/newFunction";
import { Formatter } from "utils/formatter";

function LabDetailsPage({ data }) {
  const [tabs, setTabs] = useState(() => data?.tabs || []);
  const [activeTab, setActiveTab] = useState(() => tabs?.[0]);

  useEffect(() => {
    setTabs(data?.tabs || []);
    setActiveTab(data?.tabs[0]);
  }, [data?.tabs]);

  const breadcrumb = useMemo(() => {
    if (activeTab) {
      return data?.breadcrumb?.concat({ title: activeTab.tabName });
    }
    return data?.breadcrumb;
  }, [activeTab]);

  const onTabChange = (slug: string) => {
    setActiveTab(tabs?.find((item) => item?.slug === slug));
  };
  const metaTag = data?.metaTag;
  return (
    <Tab
      data={{ ...data, tabs }}
      onTabChange={onTabChange}
      activeTab={activeTab}
      metaTag={metaTag}
      changeLanguageLink={data?.changeLanguageLink}
      breadcrumb={breadcrumb}
    />
  );
}

// export const getStaticPaths: GetStaticPaths = async () => {
//   const apiServiceFA = new ApiService("fa");
//   const apiServiceEN = new ApiService("en");

//   const response = await Promise.all([
//     apiServiceFA.getLabList(),
//     apiServiceEN.getLabList(),
//   ]);

//   if (checkEmpty(...response)) {
//     throw new Error();
//   }

//   const normalizedLabs = [
//     ...labPageNormalizer(response[0]).labs,
//     ...labPageNormalizer(response[1]).labs,
//   ];

//   const paths = normalizedLabs.map((item) => ({
//     params: {
//       entityId: String(item?.id) || "",
//       slug: item?.slug || "",
//     },
//   }));

//   return {
//     paths,
//     fallback: true,
//   };
// };

// export const getStaticProps: GetStaticProps = async ({ params, locale }) => {
//   const apiService = new ApiService(locale);
//   const entityId = params?.entityId || "";

//   const requests = [
//     apiService.getContentByEntityId(+entityId), // 0
//   ];

//   const response = await ApiService.multipleRequest(requests);
//   if (checkEmpty(...response)) {
//     throw new Error();
//   }

//   const target = response?.[0]?.[0];
//   const tabsResult = normalizeResearchContentsWithDetails(
//     normalizeResearchContents(target?.researchContents)
//   );

//   return {
//     props: {
//       data: {
//         breadcrumb: target?.breadcrumb || [],
//         tabs: tabsResult,
//         metaTag: target?.metaTag || [],
//         changeLanguageLink: target?.changeLanguageLink?.value || "",
//       },
//     },
//     revalidate: REVALIDATE_TIME,
//   };
// };
export const getServerSideProps: GetServerSideProps = async ({
  params,
  locale,
}) => {
  const apiService = new ApiService(locale);
  const entityId = params?.slug?.[0] || "";
  const slug = params?.slug?.[1] || "";

  if (Number.isNaN(+entityId)) {
    return {
      notFound: true,
    };
  }

  try {
    const requests = [
      apiService.getResearchCenterById(+entityId, { formatter: false }), // 0
    ];
    let response = [];
    try {
      response = await ApiService.multipleRequest(requests);
    } catch (e) {}
    if (is404(response?.[0])) {
      return {
        notFound: true,
      };
    }
    const target = Formatter.formatData({ data: response?.[0] })?.[0];

    if (!isCorrectLocale(target, locale)) {
      return {
        notFound: true,
      };
    }
    const normalized = labDetailsNormalizer(target);
    if (normalized.slug && normalized.slug !== slug) {
      return {
        redirect: {
          permanent: true,
          destination: `${
            locale === "en" ? "/en" : ""
          }/labs/${entityId}/${encodeURIComponent(normalized.slug)}`,
        },
      };
    }

    return {
      props: {
        data: {
          breadcrumb: normalized?.breadcrumb || [],
          tabs: normalized.tabs,
          metaTag: normalized?.metaTag || [],
          changeLanguageLink: normalized?.changeLanguageLink || "",
          noIndex: normalized?.noIndex,
        },
      },
    };
  } catch (err) {
    console.log("err", err);
    return {
      redirect: {
        destination: "/500",
        permanent: false,
      },
    };
  }
};

export default LabDetailsPage;
